import { createContext, useContext } from 'react';
import io, { IOSocket } from 'socket.io-client';
import { InBingoEvents } from '../types/bingo-events/in/backend';
import { OutBingoEvents } from '../types/bingo-events/out/backend';
import { InChatEvents } from '../types/bingo-events/in/chat';
import { OutChatEvents } from '../types/bingo-events/out/chat';

Object.assign(window, { io });

export type BackendSocket = IOSocket<InBingoEvents, OutBingoEvents>;

export type ChatSocket = IOSocket<InChatEvents, OutChatEvents>;

export type SocketStreams = {
    createBackend: () => BackendSocket;
    createChat: () => ChatSocket;
};

export const SocketContext = createContext({} as SocketStreams);

export const createSocket = (url: string, autoReconnect = true) => {
    let origin = window.location.origin;
    let path = url;

    if (url.match(/^(wss?)|(https?):\/\//)) {
        const $url = new URL(url);
        origin = $url.origin;
        path = $url.pathname;
    }

    return io(origin, {
        reconnection: autoReconnect,
        path,
        transports: ['websocket'],
    });
};

export const createBackendSocket = (): BackendSocket => {
    // Default to false (manual reload required) unless explicitly set to 'true'
    const autoReconnect = process.env.REACT_APP_WS_AUTO_RECONNECT === 'true';
    return createSocket(
        process.env.REACT_APP_WS_BACKEND_URL || '/ws-backend',
        autoReconnect
    );
};

export const createChatSocket = (): ChatSocket =>
    createSocket(process.env.REACT_APP_WS_CHAT_URL || '/ws-chat', true);

export const useSocket = () => useContext(SocketContext);
